import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridState) {
  return getRequest(
    `blogs`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `blogs/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return putRequest(
    `blogs/toggle/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return formDataPostRequest(
    `blogs`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data, id) {
    return formDataPostRequest(
    `blogs/${id}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const blogService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
};
